webpackJsonp([62778679897657],{

/***/ 1228:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _book012x = __webpack_require__(2561);
	
	var _book012x2 = _interopRequireDefault(_book012x);
	
	var _book022x = __webpack_require__(2562);
	
	var _book022x2 = _interopRequireDefault(_book022x);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var assets = {
	  hero: {
	    alt: 'Preview of the Ebook: Getting Started with Design Systems',
	    src: _book012x2.default,
	    hasShadow: false,
	    maxWidth: 556
	  },
	  second: {
	    alt: 'Getting Started with Design Systems on iPad.',
	    src: _book022x2.default,
	    hasShadow: false,
	    maxWidth: 541
	  }
	};
	
	exports.default = assets;
	module.exports = exports['default'];

/***/ }),

/***/ 1229:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _propTypes = __webpack_require__(3);
	
	var _propTypes2 = _interopRequireDefault(_propTypes);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var Bold = function Bold(props) {
	  return _react2.default.createElement(
	    'span',
	    { className: 'fontWeight-6' },
	    props.children
	  );
	};
	
	Bold.propTypes = {
	  children: _propTypes2.default.node
	};
	
	exports.default = Bold;
	module.exports = exports['default'];

/***/ }),

/***/ 1230:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _bold = __webpack_require__(1229);
	
	var _bold2 = _interopRequireDefault(_bold);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var learnings = [{
	  id: 0,
	  text: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _bold2.default,
	      null,
	      'The basic principles'
	    ),
	    ' of Design Systems, with their complexities de-mythed.'
	  )
	}, {
	  id: 1,
	  text: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _bold2.default,
	      null,
	      'Why Design Systems matter'
	    ),
	    ', from preventing inconsistencies, simplifying processes for future projects and harmonising your products.'
	  )
	}, {
	  id: 2,
	  text: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _bold2.default,
	      null,
	      'Best practice'
	    ),
	    ' for you and your team to get started in building a successful Design System.'
	  )
	}, {
	  id: 3,
	  text: _react2.default.createElement(
	    'span',
	    null,
	    _react2.default.createElement(
	      _bold2.default,
	      null,
	      'Expos\xE9 on the Design System behind Marvel'
	    ),
	    ', learn more about the workflow that works for us.'
	  )
	}];
	exports.default = learnings;
	module.exports = exports['default'];

/***/ }),

/***/ 2561:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/book-01@2x-b8c875f9b5e525671b6934f7e7a8fdeb.jpg";

/***/ }),

/***/ 2562:
/***/ (function(module, exports, __webpack_require__) {

	module.exports = __webpack_require__.p + "static/book-02@2x-119347e2ef9b05f70a703f8872f98635.png";

/***/ }),

/***/ 1265:
/***/ (function(module, exports, __webpack_require__) {

	'use strict';
	
	exports.__esModule = true;
	
	var _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; };
	
	exports.default = EbookDesignSystems;
	
	var _react = __webpack_require__(1);
	
	var _react2 = _interopRequireDefault(_react);
	
	var _grid = __webpack_require__(5);
	
	var _grid2 = _interopRequireDefault(_grid);
	
	var _heading = __webpack_require__(7);
	
	var _heading2 = _interopRequireDefault(_heading);
	
	var _pageWrap = __webpack_require__(8);
	
	var _pageWrap2 = _interopRequireDefault(_pageWrap);
	
	var _paragraph = __webpack_require__(9);
	
	var _paragraph2 = _interopRequireDefault(_paragraph);
	
	var _maxWidth = __webpack_require__(10);
	
	var _maxWidth2 = _interopRequireDefault(_maxWidth);
	
	var _spacing = __webpack_require__(4);
	
	var _spacing2 = _interopRequireDefault(_spacing);
	
	var _HeadingBlock = __webpack_require__(13);
	
	var _HeadingBlock2 = _interopRequireDefault(_HeadingBlock);
	
	var _Image = __webpack_require__(6);
	
	var _Image2 = _interopRequireDefault(_Image);
	
	var _Page = __webpack_require__(16);
	
	var _Page2 = _interopRequireDefault(_Page);
	
	var _TickedCopy = __webpack_require__(95);
	
	var _TickedCopy2 = _interopRequireDefault(_TickedCopy);
	
	var _WebinarForm = __webpack_require__(467);
	
	var _WebinarForm2 = _interopRequireDefault(_WebinarForm);
	
	var _assets = __webpack_require__(1228);
	
	var _assets2 = _interopRequireDefault(_assets);
	
	var _metadata = __webpack_require__(22);
	
	var _metadata2 = _interopRequireDefault(_metadata);
	
	var _hubspot = __webpack_require__(46);
	
	var _learnings = __webpack_require__(1230);
	
	var _learnings2 = _interopRequireDefault(_learnings);
	
	var _generalModule = __webpack_require__(1501);
	
	var _generalModule2 = _interopRequireDefault(_generalModule);
	
	var _LandingPagesWrap = __webpack_require__(67);
	
	var _LandingPagesWrap2 = _interopRequireDefault(_LandingPagesWrap);
	
	function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }
	
	var meta = {
	  title: _metadata2.default['ebook-design-systems'].title,
	  meta: [{
	    name: 'description',
	    content: _metadata2.default['ebook-design-systems'].description
	  }],
	  header: false,
	  footer: true
	};
	
	var messaging = {
	  header: _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'xs', position: 'bottom' },
	    _react2.default.createElement(
	      _heading2.default,
	      { tag: 'h1', size: 'xxl', weight: 'semibold' },
	      'Download the eBook, for free!'
	    )
	  ),
	  copy: _react2.default.createElement(
	    _spacing2.default,
	    { type: 'margin', size: 'l', position: 'bottom' },
	    _react2.default.createElement(
	      _paragraph2.default,
	      { size: 'm', color: 'silver' },
	      'Simply fill out your details below to grab your copy of the eBook.'
	    )
	  )
	};
	
	function EbookDesignSystems() {
	  return _react2.default.createElement(
	    _Page2.default,
	    meta,
	    _react2.default.createElement(
	      _LandingPagesWrap2.default,
	      { color: 'black' },
	      _react2.default.createElement(
	        'div',
	        { id: 'enterprise-form', style: { backgroundColor: '#FCE0D4' } },
	        _react2.default.createElement(
	          _pageWrap2.default,
	          null,
	          _react2.default.createElement(
	            _spacing2.default,
	            { size: 'xl', position: 'top', type: 'padding' },
	            _react2.default.createElement(
	              _spacing2.default,
	              { size: 'xl', position: 'topBottom', type: 'padding' },
	              _react2.default.createElement(
	                _grid2.default,
	                { columns: 12, alignContent: 'center' },
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    _spacing2.default,
	                    { type: 'margin', size: 's', position: 'bottom' },
	                    _react2.default.createElement(_HeadingBlock2.default, {
	                      justifyM: 'start',
	                      headingSize: 'xxxxl',
	                      paragraphSize: 'xxl',
	                      paragraphMaxWidth: 600,
	                      headingMaxWidth: 600,
	                      title: 'Getting Started with Design Systems',
	                      copy: _react2.default.createElement(
	                        'span',
	                        null,
	                        'A free guide that\'s simple in structure, human in explanation and packed with insight'
	                      )
	                    })
	                  ),
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.imageEbookHero },
	                    _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.hero, { useImageTag: true }))
	                  ),
	                  _react2.default.createElement(
	                    _spacing2.default,
	                    { type: 'padding', position: 'topBottom', size: 'm' },
	                    _react2.default.createElement(_HeadingBlock2.default, {
	                      justifyM: 'start',
	                      headingSize: 'xxl',
	                      paragraphMaxWidth: 600,
	                      headingMaxWidth: 450,
	                      title: 'What does it take to build a Design System? ',
	                      copy: _react2.default.createElement(
	                        'span',
	                        null,
	                        'They\'ve been proven to help teams drive faster development, eliminate inconsistency, save money and reduce knowledge silos. Un-arguably, it\'s a win-win situation. But how do you get started? We\'re proud to present an introductory guide to Design Systems, created to remove the overwhelming overhead a task like this can have.'
	                      )
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6, fullWidth: true },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.formPosition },
	                    _react2.default.createElement(
	                      'div',
	                      { className: _generalModule2.default.formBorder },
	                      _react2.default.createElement(
	                        'div',
	                        { className: _generalModule2.default.formPadding },
	                        _react2.default.createElement(_WebinarForm2.default, {
	                          headerTitle: messaging.header,
	                          headerText: messaging.copy,
	                          btnColor: 'blue',
	                          ctaCopy: 'Download the eBook',
	                          infoMessage: 'Download the eBook',
	                          hubspotId: _hubspot.formEbookDesignSystems,
	                          url: '/resources/thanks-for-downloading-getting-started-how-to-build-design-system',
	                          disallowedFields: ['phoneNumber']
	                        })
	                      )
	                    )
	                  )
	                )
	              ),
	              _react2.default.createElement(
	                _grid2.default,
	                { columns: 12 },
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    _maxWidth2.default,
	                    { value: 600 },
	                    _react2.default.createElement(
	                      'div',
	                      { className: 'paddingTop-l' },
	                      _react2.default.createElement(
	                        _spacing2.default,
	                        { type: 'margin', position: 'topBottom', size: 'm' },
	                        _react2.default.createElement(
	                          _heading2.default,
	                          { tag: 'h2', size: 'xxl', weight: 'semibold' },
	                          'What you\'ll learn:'
	                        )
	                      )
	                    ),
	                    _learnings2.default.map(function (item) {
	                      return _react2.default.createElement(
	                        _spacing2.default,
	                        { type: 'padding', position: 'bottom', size: 's' },
	                        _react2.default.createElement(
	                          _TickedCopy2.default,
	                          {
	                            isCentered: false,
	                            key: item.id,
	                            size: 'l',
	                            shouldShowBlackTick: true
	                          },
	                          item.text
	                        )
	                      );
	                    })
	                  )
	                ),
	                _react2.default.createElement(
	                  _grid.GridItem,
	                  { columnSpan: 12, columnSpanM: 6 },
	                  _react2.default.createElement(
	                    'div',
	                    { className: _generalModule2.default.imageEbookBottom },
	                    _react2.default.createElement(_Image2.default, _extends({}, _assets2.default.second, { useImageTag: true }))
	                  )
	                )
	              )
	            )
	          )
	        )
	      )
	    )
	  );
	}
	module.exports = exports['default'];

/***/ }),

/***/ 1501:
/***/ (function(module, exports) {

	// removed by extract-text-webpack-plugin
	module.exports = {"formBorder":"src-pages-ebook-design-systems-style----general-module---formBorder---3dVdp bg-white padding-m borderRadius-l","formPosition":"src-pages-ebook-design-systems-style----general-module---formPosition---2r6eR padding-0 breakPointS-padding-l marginLeft-0 breakPointM-marginLeft-xl","formPadding":"src-pages-ebook-design-systems-style----general-module---formPadding---3AW9C padding-0 breakPointS-padding-l","imageEbookHero":"src-pages-ebook-design-systems-style----general-module---imageEbookHero---mKgIk","imageEbookBottom":"src-pages-ebook-design-systems-style----general-module---imageEbookBottom---3dOyk breakPointM-marginLeft-xl"};

/***/ })

});


// WEBPACK FOOTER //
// component---src-pages-ebook-design-systems-index-js-e8fb293636d4543e7fad.js